/**
 * 顧客一覧パネルコンポーネント
 *
 * 顧客のリスト表示、検索、追加ボタンを含むサイドパネル
 */

import {
  Paper,
  Group,
  TextInput,
  Button,
  Text,
  Loader,
  Center,
  Stack,
  ScrollArea,
} from "@mantine/core";
import { Settings, Plus } from "lucide-react";
import { Customer } from "../../services/customerService";
import { CustomerListItem } from "./CustomerListItem";

interface CustomerListPanelProps {
  customers: Customer[];
  loading: boolean;
  selectedCustomerId: string | null;
  onSelect: (customerId: string) => void;
  onEdit: (e: React.MouseEvent, customer: Customer) => void;
  onAddClick: () => void;
}

/**
 * 顧客一覧パネル
 */
export function CustomerListPanel({
  customers,
  loading,
  selectedCustomerId,
  onSelect,
  onEdit,
  onAddClick,
}: CustomerListPanelProps) {
  return (
    <Paper
      shadow="xs"
      p="md"
      radius="md"
      withBorder
      style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <Group mb="sm" gap="xs">
        <TextInput
          placeholder="検索..."
          leftSection={<Settings size={14} />}
          disabled
          style={{ flex: 1 }}
        />
        <Button
          variant="light"
          onClick={onAddClick}
          leftSection={<Plus size={16} />}
          px="xs"
        >
          追加
        </Button>
      </Group>

      <ScrollArea style={{ flex: 1 }}>
        {loading ? (
          <Center py="xl">
            <Loader size="sm" />
          </Center>
        ) : customers.length === 0 ? (
          <Text c="dimmed" ta="center" py="xl" size="sm">
            顧客がいません
          </Text>
        ) : (
          <Stack gap="xs">
            {customers.map((customer) => (
              <CustomerListItem
                key={customer.customerId}
                customer={customer}
                isSelected={customer.customerId === selectedCustomerId}
                onClick={() => onSelect(customer.customerId)}
                onEdit={(e) => onEdit(e, customer)}
              />
            ))}
          </Stack>
        )}
      </ScrollArea>
    </Paper>
  );
}
